var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.backgroundDivStyle)},[_c('v-btn',{staticClass:"KoioteButtonFeedback",style:(_vm.buttonStyle),attrs:{"id":_vm.buttonId},on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.responsiveLabel)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }